/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Pale_Elk_GrazeInputs */

const en_soft_pale_elk_graze = /** @type {(inputs: Soft_Pale_Elk_GrazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No versions yet`)
};

const de_soft_pale_elk_graze = /** @type {(inputs: Soft_Pale_Elk_GrazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Versionen vorhanden`)
};

/**
* | output |
* | --- |
* | "No versions yet" |
*
* @param {Soft_Pale_Elk_GrazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_pale_elk_graze = /** @type {((inputs?: Soft_Pale_Elk_GrazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Pale_Elk_GrazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_pale_elk_graze(inputs)
	return de_soft_pale_elk_graze(inputs)
});